import VueIntro from 'vue-introjs';
import Vue from 'vue';
import moment from 'moment';
import App from './javascripts/App.vue';
import router from './router';
import store from './javascripts/store/index';
import translations from './javascripts/translations';
import './stylesheets/index.scss';

moment.locale('pt-BR'); // 'fr'

Vue.filter('capitalize', (value) => {
	if (!value) return '';
	return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
});

Vue.filter('uppercase', value => value.toUpperCase());
Vue.filter('lowercase', value => value.toLowerCase());

Vue.filter('titleCase', (str) => {
	let formatedWord;
	if (str) {
		formatedWord = str.split(/\s+/).map((item) => {
			if (item.length <= 2 || item.toLowerCase() === 'dos') {
				return item.toLowerCase();
			}
			return item.charAt(0).toUpperCase() + item.substring(1).toLowerCase();
		}).join(' ');
	}
	return formatedWord;
});


Vue.filter('date', (value) => {
	if (!value) return;
	const newDate = new Date(value.replace(' ', 'T'));
	return `${(newDate.getDate() <= 9) ? `0${newDate.getDate()}` : newDate.getDate()}/${((newDate.getMonth() + 1) <= 9) ? `0${(newDate.getMonth() + 1)}` : (newDate.getMonth() + 1)}/${newDate.getFullYear()} - ${(newDate.getHours() <= 9) ? `0${newDate.getHours()}` : newDate.getHours()}:${(newDate.getUTCMinutes() <= 9) ? `0${newDate.getUTCMinutes()}` : newDate.getUTCMinutes()}`;
});

Vue.filter('dateOnly', (value) => {
	if (!value) {
		return;
	}
	return new Date(value).toLocaleDateString('pt-BR')
});

Vue.filter('parseMinutes', (value) => {
	if (!value) return;
	return moment.duration({"seconds": value}).humanize();
});

Vue.filter('renderLineBreaks', (value) => {
	if (!value) return;
	return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
});

Vue.use(VueIntro);

new Vue({ // eslint-disable-line no-new
	el: '#app',
	router,
	store,
	translations,
	render: h => h(App),
});




// WEBPACK FOOTER //
// ./_source/main.js